// Fuel Consumption units with conversion factors
// Note: Fuel consumption is different from fuel efficiency - it measures fuel used per distance
// Base unit: Liters per 100 kilometers (L/100km)
export const fuelConsumptionUnits = [
  { id: 'liters-per-100km', name: 'Liter/100 Kilometers', symbol: 'L/100km', plural: 'Liters/100 Kilometers', factor: 1 },
  { id: 'miles-per-gallon-us', name: 'Mile/Gallon (US)', symbol: 'mpg', plural: 'Miles/Gallon (US)', factor: 'inverse', constant: 235.215 },
  { id: 'miles-per-gallon-uk', name: 'Mile/Gallon (UK)', symbol: 'mpg UK', plural: 'Miles/Gallon (UK)', factor: 'inverse', constant: 282.481 },
  { id: 'kilometers-per-liter', name: 'Kilometer/Liter', symbol: 'km/L', plural: 'Kilometers/Liter', factor: 'inverse', constant: 100 },
  { id: 'liters-per-km', name: 'Liter/Kilometer', symbol: 'L/km', plural: 'Liters/Kilometer', factor: 0.01 },
  { id: 'gallons-per-100miles-us', name: 'Gallon/100 Miles (US)', symbol: 'gal/100mi', plural: 'Gallons/100 Miles (US)', factor: 0.425144 },
];

export const popularFuelConsumptionConversions = [
  { from: 'liters-per-100km', to: 'miles-per-gallon-us' },
  { from: 'miles-per-gallon-us', to: 'liters-per-100km' },
  { from: 'liters-per-100km', to: 'miles-per-gallon-uk' },
  { from: 'miles-per-gallon-uk', to: 'liters-per-100km' },
  { from: 'kilometers-per-liter', to: 'liters-per-100km' },
  { from: 'liters-per-100km', to: 'kilometers-per-liter' },
  { from: 'miles-per-gallon-us', to: 'miles-per-gallon-uk' },
  { from: 'miles-per-gallon-uk', to: 'miles-per-gallon-us' },
  { from: 'liters-per-km', to: 'liters-per-100km' },
  { from: 'gallons-per-100miles-us', to: 'liters-per-100km' },
  { from: 'kilometers-per-liter', to: 'miles-per-gallon-us' },
  { from: 'miles-per-gallon-us', to: 'kilometers-per-liter' },
];

export const getUnitById = (id) => fuelConsumptionUnits.find(unit => unit.id === id);

export const convertFuelConsumption = (value, fromId, toId) => {
  if (value <= 0) return null;

  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;

  // Same unit
  if (fromId === toId) return value;

  // Step 1: Convert to base unit (L/100km)
  let baseValue;

  if (fromUnit.factor === 'inverse') {
    // For inverse units (mpg, km/L), convert using: L/100km = constant / value
    baseValue = fromUnit.constant / value;
  } else {
    // For direct units (L/km, gal/100mi), convert using factor
    baseValue = value / fromUnit.factor;
  }

  // Step 2: Convert from base unit to target unit
  if (toUnit.factor === 'inverse') {
    // For inverse units (mpg, km/L), convert using: value = constant / L/100km
    return toUnit.constant / baseValue;
  } else {
    // For direct units (L/km, gal/100mi), convert using factor
    return baseValue * toUnit.factor;
  }
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert ${fromUnit.plural.toLowerCase()} (${fromUnit.symbol}) to ${toUnit.plural.toLowerCase()} (${toUnit.symbol}) and learn the conversion formula.`;
};
